/** Chip del estado de un mensaje (bitácora, constancia, prueba). */

import type { EstadoMensajeOficial } from "../types";
import { ESTADO_MENSAJE } from "../logic/textos";

export function ChipEstadoMensaje({ estado, className = "" }: { estado: EstadoMensajeOficial; className?: string }) {
  const info = ESTADO_MENSAJE[estado] ?? { label: String(estado || "sin estado"), cls: "bg-slate-100 text-slate-500" };
  return (
    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full whitespace-nowrap ${info.cls} ${className}`}>
      {info.label}
    </span>
  );
}

export default ChipEstadoMensaje;
